import InvoiceTable from "./InvoiceTable";

export default InvoiceTable;
